export const localDateParse = (value) => {
  if (value) {
    return {
      value: new Date(value).toLocaleDateString()
    }
  } else {
    return ''
  }
}

export const localDatetimeParse = (value) => {
  if (value) {
    return {
      value: new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString()
    }
  } else {
    return ''
  }
}

export const configDate = (date) => {
  if (date) {
    return {
      value: date.replace(/(\d{4})(\d{2})(\d{2})/, '$3/$2/$1')
    }
  } else {
    return ''
  }
}

export const configDateInput = (date) => {
  if (date) {
    return {
      value: date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
    }
  } else {
    return ''
  }
}
